"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAWSS3Client = getAWSS3Client;
exports.getAbacusRoyaltiesClient = getAbacusRoyaltiesClient;
exports.getAbacusStateClient = getAbacusStateClient;
exports.getLogger = getLogger;
exports.getS3Client = getS3Client;
exports.getSecretsClient = getSecretsClient;
exports.getSecretsManager = getSecretsManager;
exports.getSnowflakeClient = getSnowflakeClient;
exports.getSnowflakePool = getSnowflakePool;
exports.initSentry = initSentry;
var _clientS = require("@aws-sdk/client-s3");
var _clientSecretsManager = require("@aws-sdk/client-secrets-manager");
var Sentry = _interopRequireWildcard(require("@sentry/node"));
var _snowflakeSdk = _interopRequireDefault(require("snowflake-sdk"));
var _winston = _interopRequireDefault(require("winston"));
var _apiRoyaltiesClient = require("@abacus/api-royalties-client");
var _apiStateClient = require("@abacus/api-state-client");
var _commonTypes = require("@abacus/common-types");
var _commonUtils = require("@abacus/common-utils");
var _secretsManager = require("@abacus/secrets-manager");
var _snowflakeClient = require("@abacus/snowflake-client");
var _config = require("@/config");
var _s = require("@/utils/storage/s3");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
let abacusRoyaltiesClient = undefined;
function getAbacusRoyaltiesClient() {
  abacusRoyaltiesClient ??= new _apiRoyaltiesClient.AbacusRoyaltiesClient({
    env: _config.config.environment,
    identityId: _config.config.orchardIdentityId,
    throttler: new _commonUtils.SlidingWindowThrottler({
      duration: 1000,
      limit: 10
    })
  });
  return abacusRoyaltiesClient;
}
let abacusStateClient = undefined;
function getAbacusStateClient() {
  abacusStateClient ??= new _apiStateClient.AbacusStateClient({
    env: _config.config.environment,
    identityId: _config.config.orchardIdentityId,
    throttler: new _commonUtils.SlidingWindowThrottler({
      duration: 1000,
      limit: 10
    })
  });
  return abacusStateClient;
}
let awsS3Client = undefined;
function getAWSS3Client() {
  awsS3Client ??= new _clientS.S3Client({
    profile: _config.config.aws.profile,
    region: _config.config.aws.region
  });
  return awsS3Client;
}
let logger = undefined;
async function getLogger() {
  logger ??= _winston.default.createLogger({
    level: _config.config.loggerLevel,
    format: _winston.default.format.json(),
    defaultMeta: {
      service: _config.config.applicationName
    },
    transports: [new _winston.default.transports.Console({
      forceConsole: true,
      format: _winston.default.format.simple()
    })]
  });
  return logger;
}
let s3Client = undefined;
function getS3Client() {
  s3Client ??= new _s.S3Client(getAWSS3Client());
  return s3Client;
}
let secretsClient = undefined;
function getSecretsClient() {
  secretsClient ??= new _clientSecretsManager.SecretsManagerClient({
    profile: _config.config.aws.profile,
    region: _config.config.aws.region
  });
  return secretsClient;
}
let secretsManager = undefined;
function getSecretsManager() {
  secretsManager ??= new _secretsManager.SecretsManager({
    client: getSecretsClient(),
    environment: _config.config.environment,
    serviceName: _config.config.applicationName
  });
  return secretsManager;
}
let snowflakeClient = undefined;
async function getSnowflakeClient() {
  snowflakeClient ??= new _snowflakeClient.SnowflakeClient({
    database: _config.config.snowflake.database,
    environment: _config.config.snowflake.environment,
    logger: await getLogger(),
    pool: await getSnowflakePool()
  });
  return snowflakeClient;
}
let snowflakePool = undefined;
async function getSnowflakePool() {
  // Check if pool exists
  if (snowflakePool != null) {
    return snowflakePool;
  }
  let snowflakeConfig = _config.config.snowflake;

  // If private key not provided in QA, UAT or Prod
  if (snowflakeConfig.privateKey == null && snowflakeConfig.privateKeyPath == null && [_commonTypes.Environment.QA, _commonTypes.Environment.UAT, _commonTypes.Environment.Prod].includes(_config.config.environment)) {
    const secretsManager = getSecretsManager();
    const privateKey = await (0, _snowflakeClient.getPrivateKey)(secretsManager);
    snowflakeConfig = {
      ...snowflakeConfig,
      privateKey,
      privateKeyPass: undefined
    };
  }
  snowflakePool = _snowflakeSdk.default.createPool(snowflakeConfig);
  return snowflakePool;
}
let isInitSentry = false;
async function initSentry() {
  if (isInitSentry) {
    return;
  }
  isInitSentry = true;
  _config.config.sentry ??= {};
  if (_config.config.sentry.dsn == null) {
    const secretsManager = getSecretsManager();
    const dsn = await secretsManager.getCred("SENTRY_DSN");
    _config.config.sentry.dsn = dsn;
  }
  if (_config.config.sentry.dsn != null) {
    Sentry.init({
      dsn: _config.config.sentry?.dsn,
      environment: _config.config.environment
    });
  }
}